import { Link } from "react-router-dom";
import { PageLayout } from "@/components/PageLayout";
import { BLOG_POSTS } from "@/data/mock";
import { Calendar, Clock, ArrowRight } from "lucide-react";

export default function BlogPage() {
  return (
    <PageLayout>
      <section className="pt-28 lg:pt-32 pb-10 bg-gradient-to-br from-sky-50/60 via-white to-lime-50/40 text-center">
        <div className="max-w-3xl mx-auto px-5">
          <span className="inline-block text-sm font-semibold text-sky-600 tracking-wider uppercase mb-3">
            Laundry Tips & Stories
          </span>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight mb-4">
            The Blitzwash Journal
          </h1>
          <p className="text-slate-500 leading-relaxed">Practical laundry advice, garment-care guides, and stories from behind the wash.</p>
        </div>
      </section>

      <section className="py-14 bg-white">
        <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {BLOG_POSTS.map((p) => (
              <Link
                key={p.slug}
                to={`/blog/${p.slug}`}
                className="group bg-white rounded-3xl border border-slate-200 overflow-hidden hover:border-sky-300 hover:shadow-lg transition-all"
                data-testid={`blog-card-${p.slug}`}
              >
                <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                  <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-5">
                  <span className="inline-block text-[10px] font-bold text-sky-600 uppercase tracking-wider mb-2">{p.category}</span>
                  <h3 className="text-lg font-bold text-slate-900 leading-tight mb-2 group-hover:text-sky-700 transition-colors">
                    {p.title}
                  </h3>
                  <p className="text-sm text-slate-500 leading-snug mb-4 line-clamp-2">{p.excerpt}</p>
                  <div className="flex items-center gap-4 text-xs text-slate-400 mb-4">
                    <span className="inline-flex items-center gap-1"><Calendar className="w-3 h-3" /> {p.date}</span>
                    <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" /> {p.readTime}</span>
                  </div>
                  <span className="inline-flex items-center gap-1 text-sm font-semibold text-sky-600 group-hover:gap-2 transition-all">
                    Read more <ArrowRight className="w-3.5 h-3.5" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
